import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from '../../utils/AuthContext';
import { authApi } from "../../backend_urls/authApi";
import { AuthURL } from "../../routes/auth_routes/AuthURL";
import { UserURL } from "../../routes/user_routes/UserURL";
import { AdminURL } from "../../routes/admin_routes/AdminURL";
import { CAURL } from "../../routes/ca_routes/CAURL";
import BaseIcon from "../../components/svg_icons/BaseIcon";
import LoadingSpinner from "../../components/loaders/LoadingSpinner";
import "../../css/pages/auth_pages/LoginPage.css";

const ROLE_REDIRECTS = {
    user: UserURL.USER_DASHBOARD,
    admin: AdminURL.ADMIN_DASHBOARD,
    ca: CAURL.CA_DASHBOARD,
};

const LoginPage = () => {
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => { setShowPassword((prev) => !prev); };

    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const [formData, setFormData] = useState({ email: "", password: "" });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setError("");
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        setError("");

        try {
            const res = await authApi.userLogin(formData);
            if (!res?.token || !res?.user) {
                throw new Error("Invalid response from server");
            }

            login({ accessToken: res.token, user: res.user });

            // role-based redirect
            const roleBasedPath = ROLE_REDIRECTS[res.user.role] || ROLE_REDIRECTS.user;
            const from = location.state?.from?.pathname;
            // Priority: "If" Previous page "else" Role-based dashboard
            const redirectPath = from || roleBasedPath;
            const absolutePath = redirectPath.startsWith("/") ? redirectPath : `/${redirectPath}`;

            navigate(absolutePath, { replace: true });
        } catch (err) {
            const errorMsg =
                err?.response?.data?.message ||
                err?.response?.data?.detail ||
                "Login failed. Try again.";

            setError(errorMsg);
        } finally { setLoading(false); }
    };

    return (
        <>
            {loading && <LoadingSpinner />}
            {error && <p className="error-text">{error}</p>}

            <div className="login-container">
                <h1>Sign In</h1>
                <p>Manage your finances, compliance and business operations from one place.</p>
                <br />
                <form onSubmit={handleSubmit}>
                    <div className="login-input-group mt-4">
                        <label className="custom-field one">
                            <BaseIcon name="mail" className="bi bi-envelope-at input-icon" />
                            <input
                                type="text" placeholder=" " name="email"
                                value={formData.email} onChange={handleChange}
                            />
                            <span className="placeholder">Email ID</span>
                        </label>

                        <br /><br />

                        <label className="custom-field one password-field">
                            <BaseIcon name="incognito" className="bi bi-incognito input-icon" />
                            <input
                                type={showPassword ? "text" : "password"} placeholder=" " name="password"
                                value={formData.password} onChange={handleChange}
                            />
                            <span className="placeholder">Password</span>
                            <span className="toggle-password-icon" onClick={togglePasswordVisibility}>
                                {showPassword ? (
                                    // Visible password
                                    <BaseIcon name="eyeOpen" />
                                ) : (
                                    // Hidden password
                                    <BaseIcon name="eyeClosed" />
                                )}
                            </span>
                        </label>
                        <br />
                        <div className="login-button-container">
                            <button type="submit" className="login-button" disabled={loading}>
                                {loading ? "Signing in..." : "Sign In"}
                            </button>
                            <div>
                                <Link to={AuthURL.FORGOT_PASSWORD} className="not-registered-button">
                                    Forgot Password?
                                </Link>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
};

export default LoginPage;
